<template>
  <div
    v-if="showValue"
    class="tw-fixed tw-bottom-[60px] tw-left-1/2 tw-translate-x-[-50%] tw-min-w-[350px] tw-max-w-[90vw] tw-inline-flex tw-flex-col tw-justify-center tw-items-center tw-px-5 tw-py-3.5 tw-rounded-md tw-noteInfo tw-z-[99999999991100]"
    :class="`${variant}`"
  >
    <div class="tw-inline-flex tw-items-center tw-gap-2.5 main__wrapper">
      <img
        v-if="iconSrc"
        :src="iconSrc"
        class="tw-w-[18px] tw-h-[18px] icon tw-flex-shrink-0"
      />
      <span class="tw-text-[15px]">
        <!-- @slot Content of the tooltip -->
        <slot />
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, watch, Ref } from "vue";

const props = defineProps({
  /** The show status of tooltip */
  show: {
    type: Boolean,
    required: true,
  },
  /** Element id on DOM */
  id: {
    type: String,
    default: "tooltip",
  },
  /** Delay time before fading (in milliseconds) */
  delay: {
    type: Number,
    default: 4000,
  },
  /** Src of the icon, will be not shown if the value is blank */
  iconSrc: {
    type: String,
    default: "/img/tada_icon.svg",
  },
  /** Variant of tooltip.
   * Valid values: success, danger
   */
  variant: {
    type: String,
    default: "success",
  },
});

const showValue: Ref<boolean> = ref(props.show);

const emit = defineEmits([
  /** Event to emit when close the tooltip */
  "close",
]);
let timeoutId: number | null = null;

const closeTooltip = () => {
  showValue.value = false;
  emit("close");
};

onMounted(() => {
  if (props.delay) {
    timeoutId = setTimeout(() => {
      emit("close");
    }, props.delay);
  }
});

watch(
  () => props.show,
  (newValue: boolean) => {
    showValue.value = newValue;
    if (newValue && props.delay) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        closeTooltip();
      }, props.delay);
    }
  },
);
</script>
<style scoped lang="scss">
.success {
  background-color: #d9ede2;
  color: #211f58;
}
.danger {
  background-color: #fae5e1;
  color: #211f58;
}
</style>
